module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overview-layout', {
    ref: "overview",
    attrs: {
      "tableCfg": _vm.tableCfg
    },
    scopedSlots: _vm._u([{
      key: "ExtraOptions",
      fn: function(props) {
        return [_c('b-dropdown', {
          attrs: {
            "variant": "default",
            "size": "sm"
          }
        }, [_c('template', {
          slot: "button-content"
        }, [_c('i', {
          staticClass: "fa fa-cog"
        })]), _vm._v(" "), _c('b-dropdown-item', {
          on: {
            "click": function($event) {
              _vm.exportSelection('/students/download_report', 'Students.xlsx')
            }
          }
        }, [_vm._v("Export Selection")])], 2)]
      }
    }])
  }, [_c('template', {
    slot: "AdvancedFilter"
  }, [_c('b-form', {
    ref: "form",
    staticClass: "offset-md-1",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Name",
      "field": "name",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Email Address",
      "field": "email_address",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Address",
      "field": "address",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Bank info requested before",
      "type": "date",
      "field": "bankinfo_requested_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  }), _vm._v(" "), _c('detail-field', {
    staticClass: "col-md-6",
    attrs: {
      "label": "Bank info updated before",
      "type": "date",
      "field": "bankinfo_updated_before",
      "rec": _vm.searchRec,
      "vvalidate": "ok",
      "validator": _vm.validator
    },
    on: {
      "enter": _vm.doFilter
    }
  })], 1)])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5006c67c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Student/Overview.vue
// module id = 705
// module chunks = 1